// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

:root {
  --tab-width: 360px;
}

button {
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
}

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: var(--tab-width);
  height: 100%;
  background: #0a0910;
  transition: width 0.4s;
  z-index: 4;
  animation: slideOut 0.3s ease-in-out forwards;
}
.sidebar > div {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.sidebar_header {
  position: relative;
  display: flex;
  align-items: center;
  height: 72px;
  border-bottom: 1 px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 16px;
}
.sidebar_header > button {
  flex: 1 1 auto;
  display: grid;
  place-items: center;
  opacity: 0.5;
}
.sidebar_header > button > span {
  color: white;
}
.sidebar_header > button.active {
  opacity: 1;
}
.sidebar_header > .underline {
  position: absolute;
  left: 0;
  bottom: -3px;
  width: 33.33%;
  height: 4px;
  border-radius: 2px;
  background: #ff5bab;
  transition: 0.3s;
}

.tabs {
  flex: 1 1 auto;
  position: relative;
  overflow: hidden;
}
.tabs > div {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  opacity: 0;
  width: 100%;
  visibility: hidden;
  translate: 0 20px;
  transition: 0.3s;
}
.tabs > div.active {
  opacity: 1;
  visibility: visible;
  translate: 0;
  display: flex;
  gap: 1em;
  flex-direction: column;
  color: white;
}
.tabs_events-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5em;
  background-color: rgb(255, 255, 255);
  border: 1px solid #ffbcd7;
  border-radius: 4px;
  overflow: hidden;
}
.tabs_events-container_img-container {
  width: 5em;
  height: 6em;
}
.tabs_events-container_event-details {
  display: flex;
  flex-direction: column;
  gap: 0.3em;
}
.tabs_events-container_event-details_title {
  font-size: 1.3em;
  font-weight: bold;
  color: #0abab5;
}
.tabs_events-container_event-details_sub-title {
  font-size: 0.8em;
  color: #232223;
}
.tabs_events-container_event-details_sub-title > span {
  color: orange;
  font-weight: bold;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.icons > svg {
  color: #ffbcd7;
  stroke: #ffbcd7;
}

@keyframes slideOut {
  0% {
    opacity: 0;
    transform: translateX(-70px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.scss","webpack://./src/assets/scss/components/_colors.scss"],"names":[],"mappings":"AAEA;EACE,sBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,uBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;EACA,6CAAA;AADF;AAGE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AADJ;AAIE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kDAAA;EACA,mBAAA;AAFJ;AAII;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAFN;AAIM;EACE,YAAA;AAFR;AAMI;EACE,UAAA;AAJN;AAOI;EACE,kBAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AALN;;AAUA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AAPF;AASE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAPJ;AAUE;EACE,UAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;EACA,YAAA;AARJ;AAWE;EACE,aAAA;EACA,mBAAA;EAEA,mBAAA;EACA,UAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAVJ;AAYI;EACE,UAAA;EACA,WAAA;AAVN;AAaI;EACE,aAAA;EACA,sBAAA;EACA,UAAA;AAXN;AAYM;EACE,gBAAA;EACA,iBAAA;EACA,cCzHQ;AD+GhB;AAaM;EAKE,gBAAA;EACA,cC1HM;AD2Gd;AAUQ;EACE,aAAA;EACA,iBAAA;AARV;;AAiBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAdF;;AAkBE;EACE,cC7IS;ED8IT,eC9IS;AD+Hb;;AAmBA;EACE;IACE,UAAA;IACA,4BAAA;EAhBF;EAmBA;IACE,UAAA;IACA,wBAAA;EAjBF;AACF","sourcesContent":["@use \"../../assets/scss/components/imports.scss\" as awt;\n\n* {\n  box-sizing: border-box;\n}\n\n:root {\n  --tab-width: 360px;\n}\n\nbutton {\n  background: transparent;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n}\n\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: var(--tab-width);\n  height: 100%;\n  background: #0a0910;\n  transition: width 0.4s;\n  z-index: 4;\n  animation: slideOut 0.3s ease-in-out forwards;\n\n  & > div {\n    padding: 0 20px;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n\n  &_header {\n    position: relative;\n    display: flex;\n    align-items: center;\n    height: 72px;\n    border-bottom: 1 px solid rgb(255 255 255 / 10%);\n    margin-bottom: 16px;\n\n    & > button {\n      flex: 1 1 auto;\n      display: grid;\n      place-items: center;\n      opacity: 0.5;\n\n      & > span {\n        color: white;\n      }\n    }\n\n    & > button.active {\n      opacity: 1;\n    }\n\n    & > .underline {\n      position: absolute;\n      left: 0;\n      bottom: -3px;\n      width: 33.33%;\n      height: 4px;\n      border-radius: 2px;\n      background: #ff5bab;\n      transition: 0.3s;\n    }\n  }\n}\n\n.tabs {\n  flex: 1 1 auto;\n  position: relative;\n  overflow: hidden;\n\n  & > div {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    opacity: 0;\n    width: 100%;\n    visibility: hidden;\n    translate: 0 20px;\n    transition: 0.3s;\n  }\n\n  & > div.active {\n    opacity: 1;\n    visibility: visible;\n    translate: 0;\n    display: flex;\n    gap: 1em;\n    flex-direction: column;\n    color: white;\n  }\n\n  &_events-container {\n    display: flex;\n    flex-direction: row;\n    // justify-content: center;\n    align-items: center;\n    gap: 0.5em;\n    background-color: rgba(255, 255, 255, 1);\n    border: 1px solid awt.$pink-color;\n    border-radius: 4px;\n    overflow: hidden;\n    // padding: 0.2em 0;\n    &_img-container {\n      width: 5em;\n      height: 6em;\n    }\n\n    &_event-details {\n      display: flex;\n      flex-direction: column;\n      gap: 0.3em;\n      &_title {\n        font-size: 1.3em;\n        font-weight: bold;\n        color: awt.$tiffany-color;\n      }\n\n      &_sub-title {\n        & > span {\n          color: orange;\n          font-weight: bold;\n        }\n        font-size: 0.8em;\n        color: awt.$black-color;\n      }\n    }\n  }\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.icons {\n  & > svg {\n    color: awt.$pink-color;\n    stroke: awt.$pink-color;\n  }\n}\n\n@keyframes slideOut {\n  0% {\n    opacity: 0;\n    transform: translateX(-70px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n","$tiffany-color: #0abab5;\n$dark-tiffany-color: #113935;\n$tiffany-2-color: #9ae0d9;\n$pink-color: #ffbcd7;\n$dark-pink-color: #ff7db1;\n$dark-tan-color: #c99578;\n$tan-color: #eddcd2;\n$white-color: #f3f2ef;\n$black-color: #232223;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
